import { showSuccessToast } from 'design-system/Toast/showSuccessToast';

export const showBankSlipDownloadSuccessToast = (bulk = false): void => {
  if (bulk) {
    showSuccessToast('Boletos baixados.', 'Confira sua pasta de downloads.', {
      layout: 'stacked',
    });
    return;
  }

  showSuccessToast('2ª via', 'Baixada com sucesso!');
};

export const showBankSlipEmailSuccessToast = (): void => {
  showSuccessToast('2ª via', 'Enviada com sucesso!');
};
